import { connect } from "react-redux";
import { Modal } from 'antd';



function mapStateToProps(state) {
    return { homePage: state.homePage }
}

const mapDispatchToProps = (dispatch) => {
    return {
      // dispatching plain actions
      //onSelectedShirtTypeChange: (payload) => dispatch({ type: 'SELECTED_SHIRT_TYPE_CHANGED',payload }),
}
}

export default connect(mapStateToProps,mapDispatchToProps);
  
